import { gql } from '@apollo/client';

export const UPDATE_QUIZ = gql(/*GraphQL*/ `
    mutation UpdateQuiz($updateQuizInput: UpdateQuizInput) {
  updateQuiz(updateQuizInput: $updateQuizInput) {
    id
    userId
    userQuestions {
      questionId
      selectedOption {
        isAnswer
        desc
      }
    }
    isCompleted
    completedAt
  }
}`);
